import { Route, Routes, useLocation } from 'react-router-dom';
import PreviewContext from '../components/context/PreviewContext';
import ApplicationForm from '../pages/ApplicationForm';
import ApplicationFormEdit from '../pages/ApplicationFormEdit';
import LocationDetails from '../pages/locationDetails';
import LocationFormRequest from '../pages/LocationFormRequest';
import PreviewPage from '../pages/PreviewPage';
import ResultsLocations from '../pages/ResultsLocations';
import ViewApplication from '../pages/ViewApplication';
import React, { useEffect } from 'react';
import i18n from '../i18n';

export default function MicrositeLocationApp() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    if (pathname !== '/preview' && pathname !== '/location/new') {
      sessionStorage.removeItem('id');
    }
    if (pathname !== '/professionals/new') {
      localStorage.removeItem('professionalId');
    }
  }, [pathname]);

  const setLanguage = (lang: string) => {
    i18n.changeLanguage(lang === 'en-US'
      ? 'en'
      : 'el');
  };

  useEffect(() => {
    // Get the initial language and set it
    const initialLang = document?.getElementsByTagName('html')?.[0]?.getAttribute('lang');
    if (initialLang) {
      setLanguage(initialLang);
    }

    // Create a new MutationObserver instance
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const observer = new MutationObserver((mutationsList, observer) => {
      // Iterate through each mutation in the list
      for (const mutation of mutationsList) {
        // Check if the mutation is a change to the lang attribute on the html element
        if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
          // Get the new value of the lang attribute
          const mutationTarget = mutation.target as HTMLElement;
          const newLang = mutationTarget.getAttribute('lang') || '';
          setLanguage(newLang);
        }
      }
    });

    // Observe changes to the html element's attributes
    observer.observe(document.getElementsByTagName('html')[0], { attributes: true });

    // Cleanup function to disconnect the observer when the component unmounts
    return () => observer.disconnect();
  }, []);

  return <>
    <Routes>
      <Route
        path='/location/details/:id'
        element={<LocationDetails />}
      />
      <Route
        path='/'
        element={<ResultsLocations />}
      />
      <Route
        path='/location'
        element={<ResultsLocations />}
      />
      <Route
        path='/location/new'
        element={
          <PreviewContext.PreviewProvider>
            <ApplicationForm />
          </PreviewContext.PreviewProvider>
        }
      />
      <Route
        path='/preview'
        element={
          <PreviewContext.PreviewProvider>
            <PreviewPage />
          </PreviewContext.PreviewProvider>
        }
      />
      <Route
        path='/location/edit/:id'
        element={
          <PreviewContext.PreviewProvider>
            <ApplicationFormEdit />
          </PreviewContext.PreviewProvider>
        }
      />
      <Route
        path='view/:id'
        element={< ViewApplication />}
      />
      <Route
        path='/location/request-form/:id'
        element={<LocationFormRequest />}
      />
    </Routes>

  </>;
}